import type { ReactNode } from "react"
import { RoleBadge } from "~/components/RoleBadge"
import { SearchableSelect } from "~/components/ui/searchable-select"

export function KBRolePicker({
	roles,
	selected,
	onChange,
	children
}: {
	roles: { id: string; name: string; color: string }[]
	selected: string[]
	onChange: (selected: string[]) => void
	children: ReactNode
}) {
	return (
		<SearchableSelect
			multiple
			value={selected}
			onChange={onChange}
			empty="No roles found"
			options={roles.map((role) => ({
				value: role.id,
				label: role.name,
				display: <RoleBadge role={role} variant="chip" />
			}))}
		>
			{children}
		</SearchableSelect>
	)
}
